import { AiOutlineCheck } from "react-icons/ai";
import { FaArrowRightLong } from "react-icons/fa6";
import { useNavigate, NavLink } from "react-router-dom";

const MenuDescription = ({ title, sections = [], defaultText = "" }) => {

  return (
    <div className="menu-description">
      {title && <h4 className="menu-title">{title}</h4>}

      {sections.map((section, i) => (
        <div key={i} className="menu-section">
          {section.heading && (
            <h5 className="menu-heading">{section.heading}</h5>
          )}

          <ul className="menu-list">
            {(section.items || []).map((item, j) => (
              <li key={j}>
                <span className="tick-icon">
                  <FaArrowRightLong size={14} fontWeight="bold" style={{ strokeWidth: 3 }} />
                </span>

                {typeof item === "object" ? (
                  <NavLink to={item.path} className="description-link">
                    {item.label}
                  </NavLink>
                ) : (
                  item
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default MenuDescription;
